import { createSelector } from 'reselect';

import { AppState } from '../../types';

export const selectAuthRoot = (state: AppState) => state.auth;

export const selectAuthTokens = (state: AppState) => state.auth.tokens;

export const selectIsAuthenticated = createSelector(
  selectAuthRoot,
  (state) => Boolean(state.tokens.access),
);
